import { render, staticRenderFns } from "./RPCardsLayout.vue?vue&type=template&id=8eddbb18&"
import script from "./RPCardsLayout.vue?vue&type=script&lang=js&"
export * from "./RPCardsLayout.vue?vue&type=script&lang=js&"
import style0 from "./RPCardsLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./RPCardsLayout.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports